// Import Dependencies
import { lazy, useMemo } from "react";

// Local Imports
import { useThemeContext } from "app/presentation/contexts/theme/context";
import { Loadable } from "app/presentation/components/shared/Loadable";
import { SplashScreen } from "app/presentation/components/template/SplashScreen";
import { useMediaQuery } from "app/presentation/hooks";
import { defaultTheme } from "configs/theme.config";

// ----------------------------------------------------------------------

const themeLayouts = {
  "main-layout": lazy(() => import("./MainLayout")),
  sideblock: lazy(() => import("./Sideblock")),
  // Fallback for admin context: use Sideblock or MainLayout
  tablet: lazy(() => import("./Sideblock")),
};

export function DynamicLayout() {
  const { themeLayout } = useThemeContext();
  
  // Détection automatique pour tablette (iPad / Android Tablet) via media query
  const isTablet = useMediaQuery("(min-width: 641px) and (max-width: 1366px)");
  const isDriverMode = (import.meta.env.VITE_APP_MODE || import.meta.env.MODE) === "driver";

  // Si on est en mode chauffeur sur une tablette ou un écran large (jusqu'à 1366px), on utilise le layout avec navigation pillule
  const forcedTabletLayout = (isTablet && isDriverMode) ? "tablet" : null;

  // Fallback vers le layout par défaut si le layout actuel n'existe pas
  const activeLayout = forcedTabletLayout || (themeLayouts[themeLayout] ? themeLayout : defaultTheme.themeLayout);

  const CurrentLayout = useMemo(
    () => Loadable(themeLayouts[activeLayout] || themeLayouts[defaultTheme.themeLayout], SplashScreen),
    [activeLayout],
  );

  return <CurrentLayout />;
}
